import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;
export async function renderPageWidget(context, widget, parent) {

    const el = context.document.createElement("div");
    el.classList.add("widget", "page_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        position: "relative",
        ...getBaseStyles(widget, breakpoint),
        ...getPageStyles(widget)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(el);

    const children = context.widgets.filter(w => w.parent === widget.uid);

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (renderer) {
            await renderer(context, child, el); 
        }
    }

    return el;
}

function getPageStyles(widget) {
    const styles = {};
    const props = widget?.properties?.desktop;
    const bg = props?.background;
    if (!bg) return styles;

    // SOLID COLOR
    if (bg.color.type === "solid") {
        const color = cssUtil.getCssColor(bg.color);
        if (color) styles["background-color"] = color;
    }

    // GRADIENT
    if (bg.color.type === "gradient") {
        const gradient = cssUtil.getCssGradient(bg.color);
        if (gradient) styles["background"] = gradient;
    }

    // IMAGE
    if (bg.type === "image" || bg.type === "video"){
        let url = `url(${IMAGE_CDN_ENDPOINT}/${bg.media.url})`;
        if(bg.type === "video"){
            url = `url(${IMAGE_CDN_ENDPOINT}/${bg.media.url})/ik-thumbnail.jpg)`;
        }
        styles["background-image"] = url;
        styles["background-repeat"] = 'no-repeat';
        styles["background-size"] = 'cover'
        styles["background-position"] = 'center center';
        styles["opacity"] = bg.opacity / 100;
    }

    return styles;
}